import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Button,
  Col,
  Badge,
} from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  TextInput,
  CheckboxInput,
} from "App/components/Inputs/BasicFormInputs.js";
const _ = require("lodash");

const VersionModal = ({
  edit = false,
  clone = false,
  visible = false,
  setVisible,
  version = {},
  addVersion,
  editVersion,
  cloneVersion,
  loading,
}) => {
  return (
    <Modal
      className="modal-dialog-centered formModal"
      isOpen={visible}
      data-testid="modal"
      backdrop="static"
    >
      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <div className="spinner-border">
            <span className="sr-only">loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="modal-header">
            <h2 className="modal-title">
              {edit ? "Edit" : clone ? "Clone" : "Add"} Version
            </h2>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setVisible(false)}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <Formik
            enableReinitialize={true}
            initialValues={{
              versionNumber: version?.versionNumber || "",
              name: version?.name || "",
              memo: version?.memo || "",
              isCurrent:
                version?.isCurrent === undefined ? true : version?.isCurrent,
            }}
            validationSchema={Yup.object({
              name: Yup.string()
                .required("Required")
                .max(200, "Cannot be longer than 200 characters"),
              memo: Yup.string(),
              isCurrent: Yup.boolean(),
            })}
            onSubmit={(values, { setSubmitting }) => {
              let newValues = {
                ...values,
              };
              //Convert all "" to null values
              newValues = _.transform(
                newValues,
                (result, value, key) =>
                  (result[key] = value === "" ? null : value),
              );

              if (edit) {
                editVersion({ id: version.id, ...newValues });
              } else if (clone) {
                cloneVersion({ id: version.id, ...newValues });
              } else {
                addVersion(newValues);
              }
            }}
          >
            {formikProps => {
              return (
                <>
                  <ModalBody>
                    <Form>
                      <Row className="pb-2">
                        <Col>
                          <Badge>
                            Version{" "}
                            {edit && version?.versionNumber
                              ? version.versionNumber
                              : "number will be auto-created"}
                          </Badge>
                        </Col>
                      </Row>
                      <Row>
                        <TextInput label="Name" name="name" col={12} />
                      </Row>
                      <Row>
                        <TextInput
                          label="Internal Memo"
                          name="memo"
                          col={12}
                          type="textarea"
                        />
                      </Row>
                      <Row>
                        <CheckboxInput
                          col={6}
                          enablevalidation={false}
                          name="isCurrent"
                        >
                          Current
                        </CheckboxInput>
                      </Row>
                    </Form>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      onClick={formikProps.submitForm}
                      color="primary"
                      type="submit"
                      data-testid="submitbutton"
                    >
                      {edit ? "Edit" : clone ? "Clone" : "Add"} Version
                    </Button>
                  </ModalFooter>
                </>
              );
            }}
          </Formik>
        </>
      )}
    </Modal>
  );
};

VersionModal.propTypes = {
  edit: PropTypes.bool,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  version: PropTypes.object,
  addVersion: PropTypes.func,
  editVersion: PropTypes.func,
  loading: PropTypes.bool,
};

export default VersionModal;
